import React from 'react';
import { Card } from 'react-bootstrap';
import  { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap';
import { Modal, Table } from 'react-bootstrap';
import { useState }  from 'react';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useForm, Controller } from 'react-hook-form'
import { updateSelezioneAnni } from '../reduxStore/questCorrenteSlice.js'

const SelezioneAnni = () => {
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
  const [modalShow, setModalShow] = useState(false);

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }
//  FINE GESTIONE Modal
// ----------------------------------------------------------

// ----------------------------------------------------------
  // creo anniArray da questionarioCorrente:
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  const anniArray = [
    {
      "key": "perPrec",
      "value": questionarioCorrente.perPrec
    },
    {
      "key": "perCorr",
      "value": questionarioCorrente.perCorr
    },
    {
      "key": "perSucc",
      "value": questionarioCorrente.perSucc
    },
  ]
  console.log(anniArray)
// ----------------------------------------------------------


//  INIZIO GESTIONE PER react-hook-form
  const dispatch = useDispatch();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      anni: anniArray.map(({ key, value }) => ({ key, value  }))
    }
  });

  const onSubmit = (data) => {
    console.log(data);
    const updatedValues = {
        questionarioUuid: questionarioCorrente.questionarioUuid, 
        anniArray: data
    }
    console.log('Selezione Anni - updatedValues: ', updatedValues)
    
    dispatch(updateSelezioneAnni(updatedValues))
    setModalShow(false)
  };
//  FINE GESTIONE PER react-hook-form


return (
  <Card className="text-left">
    <Card.Body className="p-5">
      <h1 className="text-center">
        <strong>Selezione anni di rilevazione</strong>
      </h1>

      <hr />
  <Button variant="primary" onClick={handleOpenModal}>
    Modifica selezione anni
  </Button>
  <hr />
  <Table className="fs-10 mt-3">
        <tbody>
          {anniArray.map((anno) => (
            <tr
              key={anno.key}
              className="align-middle white-space-nowrap"
            >
              <td key="classe" className="fs-10 text-900">
                { (anno.key ==='perPrec') ? `Periodo precedente a quello della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                  (anno.key ==='perCorr') ? `Periodo oggetto della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                  (anno.key ==='perSucc') ? `Periodo successivo a quello della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                  (anno.key) }
              </td>
              <td key="alias" className="fs-10 text-900">
                {anno.value}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <hr />
      <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Selezione anni di rilevazione</Modal.Title>
          <FalconCloseButton onClick={handleCloseModal}/>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Table className="fs-10 mt-3">
            <tbody>
              {anniArray.map((anno, index) => (
                <tr key={anno.key} className="align-middle white-space-nowrap">
                  <td className="fs-10 text-900">{ (anno.key ==='perPrec') ? `Periodo precedente a quello della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                    (anno.key ==='perCorr') ? `Periodo oggetto della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                    (anno.key ==='perSucc') ? `Periodo successivo a quello della elaborazione del Valore Aggiunto Riattribuito (VAR)`: 
                    (anno.key) }
                  </td>
                  <td className="fs-10 text-900">
                  <Controller
                    name={`anni[${index}].value`}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        size="10"
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                  </td>
                </tr>
              ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
            <Button variant="primary" type="submit">Invia</Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Card.Body>
  </Card>
);

};

export default SelezioneAnni;
